import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { PostOrderObj, PostOrderState } from "../../types/types";

export const postOrder = createAsyncThunk<PostOrderObj, PostOrderObj>(
  "postOrder/postOrder",
  async (orderData) => {
    // Проверяем, есть ли данные для отправки
    if (!orderData || Object.keys(orderData).length === 0) {
      throw new Error("Нет данных для отправки");
    }

    // Логируем данные перед отправкой
    console.log("Отправляемые данные:", orderData);

    // Выполняем запрос к API
    const API_URL = process.env.REACT_APP_URL_BACKEND;
    const response = await fetch(`${API_URL}/api/v1/orders/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(orderData),
    });

    // Проверяем, успешно ли выполнен запрос
    if (!response.ok) {
      const errorMessage = await response.text();
      throw new Error(`Ошибка при отправке заказа: ${errorMessage}`);
    }

    // Возвращаем ответ в формате JSON
    return await response.json();
  }
);

const initialState: PostOrderState = {
  order: [],
  loading: false,
  error: null,
};

const postOrderSlice = createSlice({
  name: "postOrder",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(postOrder.pending, (state) => {
        state.loading = true; // Устанавливаем флаг загрузки
      })
      .addCase(
        postOrder.fulfilled,
        (state, action: PayloadAction<PostOrderObj>) => {
          state.loading = false; // Загрузка завершена
          state.order.push(action.payload); // Добавляем новый заказ в состояние
        }
      )
      .addCase(postOrder.rejected, (state, action) => {
        state.loading = false; // Загрузка завершена
        state.error = action.error.message || "Что-то пошло не так"; // Устанавливаем сообщение об ошибке
      });
  },
});

// Селекторы для доступа к состоянию
export const selectOrder = (state: { order: PostOrderState }) =>
  state.order.order;
export const selectLoading = (state: { order: PostOrderState }) =>
  state.order.loading;
export const selectError = (state: { order: PostOrderState }) =>
  state.order.error;

export default postOrderSlice.reducer;
